import { createSlice } from "@reduxjs/toolkit";

// 카운터 리듀서 정의
const parseUrlSlice = createSlice({
  name: "parseUrl",
  initialState: {
    userId: null,
    channelId: null,
    emartBranchId: null,
    emartBranchName: null,
  },
  reducers: {
    initUserChannelId(state) {
      return {
        ...state,
        userId: null,
        channelId: null,
        emartBranchId: null,
        emartBranchName: null,
      };
    },
    setUserChannelId(state, action) {
      const { channelId, userId } = action.payload;
      return { ...state, userId, channelId };
    },
    setEmartBranch(state, action) {
      const { emartBranchId, emartBranchName } = action.payload;
      return { ...state, emartBranchId, emartBranchName };
    },
  },
});

// 액션 및 리듀서 내보내기
export const { initUserChannelId, setUserChannelId, setEmartBranch } =
  parseUrlSlice.actions;
export default parseUrlSlice.reducer;
